import _ from 'lodash';
import React from 'react';
import {Async, AsyncCreatable} from 'react-select';
import classNames from 'classnames';

import {identity} from 'utils/common';

class AsyncSelect extends React.Component<any> {
  state = {
    selectedOption: null
  };

  loadOptions = input => {
    const {
      fetchFunction,
      buildOptions = identity,
      showDropdownWhenEmpty = false
    } = this.props;

    if (!input && !showDropdownWhenEmpty) {
      return Promise.resolve({options: []});
    }

    return fetchFunction(input).then(response => ({
      options: buildOptions(response.data)
    }));
  };

  clearSelectedOption = () => this.setState({selectedOption: null});

  onClear = () => {
    this.clearSelectedOption();
    if (_.get(this.props, 'onClear')) {
      this.props.onClear();
    }
  };

  onChange = value => {
    // Handles clearing of the input value (pressing the `clear` button)
    if (_.isNull(value)) {
      return this.onClear();
    }
    this.setState({selectedOption: value}, () => this.props.onChange(value));
  };

  onNewOptionClick = opt => {
    this.setState({selectedOption: opt}, () => {
      if (_.get(this.props, 'onNewOptionClick')) {
        this.props.onNewOptionClick(opt);
      }
      this.props.onChange(opt);
    });
  };

  optionRenderer = option => {
    /*
     * When `creatable` is `true`, the creatable option has specific className:
     * https://github.com/JedWatson/react-select/blob/master/src/Creatable.js#L216
     * Since the creatable option uses hardcoded `newOptionCreator` we don't want
     * to use `optionRenderer` with it.

     * Since `optionRenderer` is optional we need to check if it's passed.
    */
    if (
      _.isEqual(option.className, 'Select-create-option-placeholder') ||
      _.isNil(this.props.optionRenderer)
    ) {
      return option[this.labelKey];
    }

    return this.props.optionRenderer(option);
  };

  // Check if such props are passed and add the default ones if they aren't
  labelKey = this.props.labelKey || 'label';
  valueKey = this.props.valueKey || 'value';

  render() {
    const AsyncComponent: any =
      (this.props.creatable && AsyncCreatable) || Async;

    return (
      <div className={classNames(this.props.className, 'AsyncSelect')}>
        <AsyncComponent
          valueKey={this.valueKey}
          labelKey={this.labelKey}
          arrowRenderer={this.props.arrowRenderer || null}
          optionRenderer={this.optionRenderer}
          valueRenderer={this.props.valueRenderer}
          loadOptions={this.loadOptions}
          onChange={this.onChange}
          value={this.state.selectedOption || this.props.value}
          placeholder={this.props.placeholder}
          onNewOptionClick={this.onNewOptionClick}
          onBlur={() => {
            this.props.onBlur && this.props.onBlur(this.props.value);
          }}
          onFocus={this.props.onFocus}
          disabled={this.props.disabled}
          promptTextCreator={this.props.promptTextCreator}
          tabSelectsValue={false}
          /*
            The dafult value of filterOptions is undefined;
            If no filterOptions are passed from props, the filterOptions will be with its default behaviour
          */
          filterOptions={this.props.filterOptions}
          menuRenderer={this.props.menuRenderer}
        />
      </div>
    );
  }
}

export default AsyncSelect;
